import { Transform } from 'class-transformer';
import { IsBoolean, IsDateString, IsOptional } from 'class-validator';

export class GlucoseConnectionStatusQueryDto {
  @IsOptional()
  @Transform(({ value }) => value === 'true' || value === true)
  @IsBoolean()
  checkNow = false;

  @IsOptional()
  @IsDateString()
  phaseStart?: string;
}
